import Calendar from './calendar/ko_KR';
import DatePicker from './date-picker/ko_KR';
import Pagination from './pagination/ko_KR';
import TimePicker from './time-picker/ko_KR';

export default {
  locale: 'ko',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'íí° ë©ë´',
    filterConfirm: 'íì¸',
    filterReset: 'ì´ê¸°í',
    selectAll: 'ëª¨ë ì í',
    selectInvert: 'ì í ë°ì ',
  },
  Modal: {
    okText: 'íì¸',
    cancelText: 'ì·¨ì',
    justOkText: 'íì¸',
  },
  Popconfirm: {
    okText: 'íì¸',
    cancelText: 'ì·¨ì',
  },
  Transfer: {
    searchPlaceholder: 'ì¬ê¸°ì ê²ìíì¸ì',
    itemUnit: 'ê°',
    itemsUnit: 'ê°',
  },
  Upload: {
    uploading: 'ìë¡ë ì¤...',
    removeFile: 'íì¼ ì­ì ',
    uploadError: 'ìë¡ë ì¤í¨',
    previewFile: 'íì¼ ë¯¸ë¦¬ë³´ê¸°',
  },
  Empty: {
    description: 'ë°ì´í° ìì',
  },
};
